<template>
  <!-- :only-countries="['US', 'CA', 'CN', 'TW']" -->
  <VuePhoneNumberInput
    ref="vuePhoneNumberInput"
    maxlength="14"
    v-show="fullData !== null"
    color="#ddd"
    valid-color="#000"
    error-color="#f5222d"
    :error="fullData ? !fullData.isValid : false"
    :default-country-code="initData.countryCode"
    :translations="phonenumberTranslations"
    :no-country-selector="false"
    :border-radius="4"
    :preferred-countries="['US', 'CA', 'CN', 'TW']"
    v-model="yourValue"
    :clearable="false"
    @update="handleUpdate"
    :disabled="disabled"
  />
</template>
<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
  name: 'PhoneNumberInput',
  components: {
    VuePhoneNumberInput
  },
  props: {
    initData: {
      type: Object,
      default: () => {return { countryCallingCode: '1', countryCode: 'US', phoneNumber: '' }}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      yourValue: '',
      phonenumberTranslations: {
        // countrySelectorLabel: null,
        // countrySelectorError: 'Choisir un pays',
        // phoneNumberLabel: null,
        example: ''
      },
      fullData: null
    }
  },
  beforeCreate () {
  },
  mounted () {
    this.fullData = {
        countryCode: this.initData.countryCode ? this.initData.countryCode : 'US',
        countryCallingCode: this.initData.countryCallingCode ? this.initData.countryCallingCode : '1',
        isValid: true,
        phoneNumber: this.initData.phoneNumber ? this.initData.phoneNumber : ''
      }
    this.yourValue = this.initData.phoneNumber
    // 如果有初始值，就要激活组件的校验机制
    if (this.initData.phoneNumber !== '') {
      this.$refs.vuePhoneNumberInput.emitValues({
          countryCode: this.fullData.countryCode,
          phoneNumber: this.fullData.phoneNumber,
      })
    } else {
      // 如果没有初始值先不显示校验内容
      this.fullData.isValid = true
    }
  },
  methods: {
    handleUpdate (value) {
      const phoneNumber = value.formatNational
      let isValid = value.isValid
      if (!this.required) {
        if (!phoneNumber || phoneNumber.length === 0) {
          isValid = true
        }
      }
      this.fullData = {
        countryCode: value.countryCode,
        countryCallingCode: value.countryCallingCode,
        isValid: isValid,
        phoneNumber: phoneNumber
        // phoneNumber: value.phoneNumber
      }
      this.$emit('update', this.copyDataByJSON(this.fullData))
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .country-selector.input-country-selector {
  input {
    border-color: #d9d9d9 !important;
  }
  .dots-text {
    color: #000;
  }
  .country-selector__list__item.selected {
    .dots-text {
      color: #fff;
    }
  }
  &.is-focused {
    input {
      box-shadow: none !important;
    }
  }
  &.has-hint, &.has-value {
    .country-selector__label {
      line-height: 18px;
    }
  }
}
::v-deep .input-tel {
  color: rgba(0, 0, 0, 0.65) !important;
  .input-tel__input {
    border-color: #d9d9d9!important;
    caret-color: #000 !important;
  }
  .country-selector__input {
    border-color: #d9d9d9!important;
    caret-color: #000 !important;
  }
  .country-selector__country-flag > .country-selector__input {
    border-color: #d9d9d9!important;
  }
  &.is-focused {
    .input-tel__input {
      box-shadow: none !important;
    }
  }
  &.has-hint, &.has-value {
    .input-tel__label {
      line-height: 18px;
    }
  }
}
//
.vue-phone-number-input /deep/.select-country-container {
  flex: 0 0 100px!important;
  width: 100px!important;
  min-width: 100px!important;
  max-width: 100px!important;
}
</style>
